const cards = [
  {
    title: '国产悬疑剧 · 烧脑必看片单',
    desc: '精选10部国产高分悬疑剧，剧情反转不断，每一集都让人欲罢不能。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20mystery%20detective%20scene%20with%20dramatic%20lighting%2C%20a%20single%20desk%20lamp%20illuminating%20case%20files%20and%20photos%20on%20a%20wooden%20table%2C%20moody%20atmosphere%2C%20warm%20light%20in%20dark%20room%2C%20film%20noir%20aesthetic%2C%20intriguing%20shadows&width=640&height=400&seq=card-genre-01&orientation=landscape',
    tag: '悬疑',
    count: '42部',
    hot: true,
  },
  {
    title: '古装剧合集 · 仙侠与权谋的交织',
    desc: '殿堂级古装大剧一网打尽，服化道精良，演技在线，沉浸式感受东方美学。',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20interior%20with%20ornate%20wooden%20carvings%20and%20silk%20curtains%2C%20soft%20sunlight%20streaming%20through%20lattice%20windows%2C%20traditional%20elegant%20aesthetic%2C%20warm%20golden%20and%20red%20tones%2C%20cinematic%20composition%2C%20rich%20cultural%20atmosphere&width=640&height=400&seq=card-genre-02&orientation=landscape',
    tag: '古装',
    count: '68部',
    hot: true,
  },
  {
    title: '都市情感剧 · 治愈你的日常生活',
    desc: '从职场奋斗到甜蜜恋爱，都市题材剧集带你感受现代人的情感世界。',
    img: 'https://readdy.ai/api/search-image?query=Modern%20city%20apartment%20interior%20with%20warm%20cozy%20lighting%2C%20two%20coffee%20cups%20on%20a%20wooden%20table%20by%20a%20large%20window%20overlooking%20a%20skyline%20at%20sunset%2C%20comfortable%20sofa%20with%20throw%20blankets%2C%20intimate%20atmospheric%20scene&width=640&height=400&seq=card-genre-03&orientation=landscape',
    tag: '都市',
    count: '56部',
    hot: false,
  },
  {
    title: '韩剧专区 · 现象级韩剧一站看',
    desc: '复仇、爱情、悬疑、治愈，韩剧总能刷新你对好故事的认知。',
    img: 'https://readdy.ai/api/search-image?query=Warm%20cozy%20Korean%20style%20rooftop%20apartment%20interior%20with%20fairy%20lights%2C%20books%20and%20plants%2C%20golden%20hour%20light%20through%20a%20large%20window%2C%20soft%20romantic%20atmosphere%2C%20cinematic%20depth%20of%20field%2C%20warm%20nostalgic%20feel&width=640&height=400&seq=card-genre-04&orientation=landscape',
    tag: '韩剧',
    count: '89部',
    hot: true,
  },
  {
    title: '美剧精选 · 高分神剧不容错过',
    desc: 'HBO、Netflix高分美剧全收录，从史诗奇幻到现代职场，题材应有尽有。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20scene%20of%20a%20New%20York%20style%20loft%20apartment%20with%20exposed%20brick%20walls%2C%20large%20industrial%20windows%2C%20warm%20evening%20light%2C%20vintage%20furniture%2C%20creative%20workspace%20aesthetic%2C%20film-like%20color%20grading%2C%20moody%20atmosphere&width=640&height=400&seq=card-genre-05&orientation=landscape',
    tag: '美剧',
    count: '73部',
    hot: false,
  },
  {
    title: '动漫番剧 · 二次元追番指南',
    desc: '热血、治愈、智斗、奇幻，这里有你想要的每一部番剧。',
    img: 'https://readdy.ai/api/search-image?query=Vibrant%20colorful%20Japanese%20anime%20style%20city%20street%20at%20dusk%20with%20neon%20signs%20and%20cherry%20blossom%20petals%20floating%2C%20warm%20golden%20and%20pink%20sky%2C%20lively%20atmosphere%2C%20cinematic%20wide%20angle%2C%20dreamy%20atmospheric%20lighting&width=640&height=400&seq=card-genre-06&orientation=landscape',
    tag: '动漫',
    count: '120部',
    hot: true,
  },
  {
    title: '经典老剧 · 值得重温的时代记忆',
    desc: '那些年错过的好剧，或是想重温的经典，都在这里等你回来。',
    img: 'https://readdy.ai/api/search-image?query=Nostalgic%20warm%20scene%20of%20a%20vintage%20living%20room%20with%20an%20old%20tube%20television%20set%2C%20cozy%20knitted%20blankets%2C%20afternoon%20sunlight%20through%20sheer%20curtains%2C%20retro%20aesthetic%2C%20soft%20warm%20color%20palette%2C%20sentimental%20atmosphere&width=640&height=400&seq=card-genre-07&orientation=landscape',
    tag: '经典',
    count: '95部',
    hot: false,
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">
          剧集分类
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          按题材分类浏览，轻松找到你喜欢的电视剧类型
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {cards.map((card, index) => (
            <div
              key={index}
              className={`group bg-background-50 rounded-2xl overflow-hidden border border-background-200 transition-all duration-300 hover:shadow-md cursor-pointer ${
                cards.length === 7 && index === 6 ? 'sm:col-span-2 lg:col-span-1 lg:col-start-2' : ''
              }`}
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                  }}
                />
                <div className="absolute top-3 left-3 flex items-center gap-2">
                  <span className="px-2.5 py-1 bg-background-50/90 text-foreground-800 text-xs font-medium rounded-full whitespace-nowrap">
                    {card.tag}
                  </span>
                  {card.hot && (
                    <span className="px-2 py-1 bg-primary-500 text-background-50 text-[10px] font-bold rounded-full whitespace-nowrap">
                      HOT
                    </span>
                  )}
                </div>
              </div>
              <div className="p-4">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="text-sm font-bold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                    {card.title}
                  </h3>
                  <span className="text-xs text-primary-500 font-medium whitespace-nowrap ml-2">{card.count}</span>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}